export default "/images/vendor/flag-icon-css/flags/4x3/es-ga.svg?23a30d01d4c6338e7f5c307f5045cfd6";